import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const MembersContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.BLUE_GRAY};
  width: 100%;
  height: auto;
`;

export const dropdownStyle = { display: 'flex', justifyContent: 'flex-end' };

export const ContainerTable = styled.div`
  margin: auto;
  width: 98%;
`;

export const FloatingButton = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  background: ${colors.GREEN_LEAF};
  color: ${colors.WHITE};
  font-size: 1rem;
  font-weight: bold;
  font-family: metropolis;
  border-radius: 0.5rem;
  width: 10vw;
  height: 5vh;
  top: 17vh;
  right: 4.75vw;
  cursor: pointer;
  z-index: 100;
  padding: 0 1rem;
`;

export default {
  MembersContainer,
  dropdownStyle,
  ContainerTable,
  FloatingButton,
};
